export default __webpack_public_path__ + "static/media/write.16519cc0.svg";